import React from 'react';
import { config } from '../../config';
import * as actionTypes from '../../consts/actionTypes';
import { __ } from '../../helpers/TranslationService';
import {
    StyledCardContainer,
    StyledCardTitle,
    StyledImg,
    StyledPhone,
    StyledPhoneContainer,
    StyledSchedule,
    StyledThunderIcon,
    StyledButton,
    PhoneCardLegalText,
} from './CruiseInquiryPhoneCardV2.style';
import { createPortal } from 'react-dom';
import { CruiseInquiryModal } from './CruiseInquiryModal';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useDispatch } from 'react-redux';

interface IProps {
    phoneNumber?: string;
    officeHours?: {
        firstLine?: string;
        secondLine?: string;
    };
    companyTitle?: string;
    isDreamdeal?: boolean;
    isAllInclusive?: boolean;
    isSoldOut: boolean;
}

export const CruiseInquiryPhoneCardV2 = ({
    phoneNumber,
    officeHours,
    isDreamdeal,
    companyTitle,
    isAllInclusive,
    isSoldOut,
}: IProps) => {
    const storeState = useTypedSelector((state) => state);
    const { requestForm, cruisePage, abTests, pageData } = storeState;
    const dispatch = useDispatch();
    const [showModal, setModalState] = React.useState(false);
    const showContactUsButton = false;

    const handleModalClose = () => {
        dispatch({
            type: actionTypes.handleInquiryResponse,
            payload: { isSubmitError: false },
        });
        setModalState(false);
    };

    return (
        <>
            <StyledCardContainer>
                <StyledCardTitle>
                    {__('contactUs.title', 'dreamlines')}
                    <StyledThunderIcon height={16} width={16} />
                </StyledCardTitle>

                <StyledPhoneContainer>
                    <StyledImg
                        src={`${config.images}/common/call-cruise-expert.png`}
                        alt={`${__('Professional, expert advice', 'dreamlines')}`}
                    />
                    <StyledPhone>
                        <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                        {officeHours?.firstLine && (
                            <StyledSchedule> {officeHours.firstLine} </StyledSchedule>
                        )}
                    </StyledPhone>
                </StyledPhoneContainer>

                {showContactUsButton && (
                    <StyledButton withArrow color="secondary" onClick={() => setModalState(true)}>
                        {__('contactUs.modalSubmit', 'dreamlines')}
                    </StyledButton>
                )}
                {!isDreamdeal && (
                    <PhoneCardLegalText
                        centerAlign={showContactUsButton}
                        dangerouslySetInnerHTML={{
                            __html: __('dreamlinesIntermediary', 'dreamlines').replace(
                                /%cruiseline%/,
                                companyTitle || '',
                            ),
                        }}
                    />
                )}
            </StyledCardContainer>

            {showModal &&
                createPortal(
                    <CruiseInquiryModal
                        onClose={handleModalClose}
                        cruisePage={cruisePage}
                        abTests={abTests}
                        defaultCurrency={pageData.brandConfig.defaultCurrency}
                        isAllInclusive={isAllInclusive}
                    />,
                    document.body,
                )}
        </>
    );
};
